var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-tooltip",
        {
          attrs: { disabled: !_vm.isTempNumber, bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                return [
                  _c(
                    "span",
                    _vm._g({ class: { "temp-number": _vm.isTempNumber } }, on),
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            !!_vm.number
                              ? _vm.number
                              : !!_vm.tempNumber
                              ? _vm.tempNumber
                              : _vm.$t("components.documentNumber.notSet")
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              }
            }
          ])
        },
        [_vm._v(" " + _vm._s(_vm.contextTooltipText) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }